type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function NavigationUserIcon(props: Props) {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M11.999 14.666c-2.37254 0-6.03556.7569-7.69956 3.215-.24882.368-.38433.8405-.24098 1.3026.14335.462.6413.8156 1.31853.8156H18.6217c.6772 0 1.1752-.3539 1.3186-.8156.1433-.4621.0078-.9346-.241-1.3026-1.6644-2.4584-5.327-3.215-7.6996-3.215h-.0007Zm0 .7618c2.1989 0 5.6663.8085 7.0688 2.8803.1378.2035.1929.4931.1443.6498-.0487.1571-.1251.2792-.5907.2792H5.37666c-.46563 0-.54204-.1224-.59069-.2792-.04865-.157.00653-.4463.14433-.6498 1.40277-2.0718 4.86987-2.8803 7.0687-2.8803ZM11.9984 4C9.68362 4 7.80835 5.87527 7.80835 8.19004v1.14318c0 2.31478 1.87527 4.19008 4.19005 4.19008 2.3148 0 4.1913-1.8753 4.1913-4.19008V8.19004C16.1897 5.87527 14.3132 4 11.9984 4Zm0 .76212c1.9059 0 3.4295 1.52196 3.4295 3.42792v1.14318c0 1.90598-1.5232 3.42788-3.4295 3.42788-1.9063 0-3.42793-1.5219-3.42793-3.42788V8.19004c0-1.90596 1.52193-3.42792 3.42793-3.42792Z"
        fill={props.fill ?? '#593B37'}
      />
    </svg>
  );
}
